import { AbstractControl, FormGroup } from '@angular/forms';

import { AbstractControl as LegacyAbstractControl } from '../../ngx-strongly-typed-forms';


export class FormControlExtensions {
    static findControlName(control: AbstractControl<any, any> | LegacyAbstractControl<any>): string {
        if (control?.parent) {
            const parentControls = control.parent.controls;
            for (const controlName in parentControls) {
                if (parentControls.hasOwnProperty(controlName) && parentControls[controlName] === control) {
                    return controlName;
                }
            }
        }
        return null;
    }

    static hasRequiredField(abstractControl: AbstractControl<any, any> | LegacyAbstractControl<any>): boolean {
        if (abstractControl == null) {
            return false;
        }
        if (abstractControl.validator) {
            const validator = abstractControl.validator({} as any);
            if (validator?.required) {
                return true;
            }
        }
        if ((abstractControl as FormGroup).controls) {
            for (const controlName in (abstractControl as FormGroup).controls) {
                if ((abstractControl as FormGroup).controls[controlName]) {
                    if (FormControlExtensions.hasRequiredField((abstractControl as FormGroup).controls[controlName])) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}
